import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import UnitConverter from './components/UnitConverter';
import SpecificPower from './components/SpecificPower';
import FAD from './components/FAD';
import SandBlasting from './components/SandBlasting';
import Cylinder from './components/Cylinder';
import PressureDrop from './components/PressureDrop';
import BeltSize from './components/BeltSize';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/specific-power" element={<SpecificPower />} />
        <Route path="/converter" element={<UnitConverter />} />
        <Route path="/fad" element={<FAD />} />
        <Route path="/sandblasting" element={<SandBlasting />} />
        <Route path="/cylinder" element={<Cylinder />} />
        <Route path="/pressure-drop" element={<PressureDrop />} />
        <Route path="/belt-size" element={<BeltSize />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
